export enum NotificationFilterEnum {
  ALL = 1,
  UNREAD = 0,
}
